import { FormGroup, FormControl } from '@angular/forms';

export type CountryConsents = Record<string, ConsentConfig[]>;
export type ConsentConfig = baseCountryConsent &
  (CountryConsent | CountryConsentsInfo);
type baseCountryConsent = {
  text?: string;
  allowedClientIds?: string[];
};

export type ConsentPurpose = {
  purposeId: string;
  id_component?: SpecificConsentsCheckboxComponentEnum; // If none specify text will be displayed as html
  text?: string;
  consentRequired?: boolean; // If true, the consent must be approved to submit the form
  isApproved?: boolean;
  allowApproval: boolean;
  sharedCheckboxId?: string; // if the purpose is part of a group, only one checkbox will be displayed for the group
};

export type CountryConsent = {
  consentCollectionPointId: string;
  consentCollectionPointVersion: number;
  consentPurposes: ConsentPurpose[]; // Purposes array id
  allowedClientIds?: string[];
};

/**
 * Allow to insert informative text between consents
 */
export type CountryConsentsInfo = {
  text: string;
  allowedClientIds?: string[];
};

export enum SpecificConsentsCheckboxComponentEnum {
  KR_PRIVACY_COLLECT = 'detail-terms-kr-privacy-collect.component',
  KR_PRIVACY_TRANSFER = 'detail-terms-kr-privacy-transfer.component',
  LEGAL_CONSENT = 'legal-consent',
}

export type CountryConsentFormGroup = FormGroup<
  Record<string, FormControl<boolean>>
>;
